import { useParams } from "@/lib/router-compat";
import { SegmentLanding } from "@/components/SegmentLanding";
import { SEGMENT_BY_SLUG } from "@/lib/segments";
import NotFound from "./NotFound";

export default function SegmentRoute({ slug: slugProp }: { slug?: string }) {
  const params = useParams<{ slug: string }>();
  const slug = slugProp ?? params.slug;
  const data = slug ? SEGMENT_BY_SLUG[slug] : undefined;

  if (!data) return <NotFound />;

  return <SegmentLanding key={data.slug} {...data} />;
}
